import "./polyfills";
import ReactDOM from "react-dom";
import promiseFinally from "promise.prototype.finally";
import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { useStrict } from "mobx";
import { Provider } from "mobx-react";
import { init } from "@sentry/browser";
import GAListener from "./GAListener";
import { $const } from "./helper";
import "element-theme-default";
import pkgConfig from "../package.json";

import App from "./components/App";

// import articlesStore from './stores/articlesStore';
// import commentsStore from './stores/commentsStore';
import authStore from "./stores/authStore";
import commonStore from "./stores/commonStore";
import languageStore from "./stores/languageStore";
import navStore from "./stores/navigationStore";
import gameStore from "./stores/gameStore";
import teamStore from "./stores/teamStore";
import personGameStore from "./stores/personGameStore";

const stores = {
  // articlesStore,
  authStore,
  commonStore,
  languageStore,
  navStore,
  gameStore,
  teamStore,
  personGameStore
};

const sentryEnv = $const.APP_NORMALIZED_ENV_MAP[process.env.APP_NORMALIZED_ENV];
const pkgVersion = pkgConfig && pkgConfig.version ? pkgConfig.version : "";
if (process.env.NODE_ENV === "production") {
  init({
    dsn: "https://52da2751da274f28aac35ed1d0f3376e@sentry.djiops.com/65",
    environment: sentryEnv,
    release: `${sentryEnv}-${pkgVersion}`
  });
}

// For easier debugging
window._____APP_STATE_____ = stores;

promiseFinally.shim();
useStrict(true);

const AnalyticsTracker = () => {
  return <Route component={GAListener} />;
};

ReactDOM.render(
  <Provider {...stores}>
    <BrowserRouter>
      <div>
        <AnalyticsTracker />
        <App />
      </div>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js